export default __webpack_public_path__ + "8d118859843561288ae0a93a6bc6aedf.png";